<div class="company-shipping-address-dropdown-action-cell-renderer__wrapper">
  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="onSetAsDesfault()">
      <i class="fas fa-check"></i> Set as Default
    </button>
    <button mat-menu-item (click)="onUpdate()">
      <i class="fas fa-edit"></i> Update
    </button>
    <button mat-menu-item (click)="onDelete()">
      <i class="fas fa-trash text-danger"></i> Delete
    </button>
  </mat-menu>
</div>
